import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { Link } from "react-router-dom";
import { DesktopContainer } from "../layouts";
import { api, constants, helpers } from "../utils";
import {
   CollapseTablePmNeeds, DynamicInput, ItemTypeahead, ServiceThreadSpinner,
   SpinnerButton, VendorTypeahead,
} from "./";

const { INPUT_TYPES } = constants;

const FieldObjects = [
   {
      name: "Order Range:",
      label: "payload.orderRange",
      listName: "OrderRangeList",
      type: INPUT_TYPES.select,
      value: { label: "Two Weeks", value: "14" },
      options: [],
   },
   {
      name: "Class:",
      label: "payload.classCode",
      listName: "ClassList",
      type: INPUT_TYPES.select,
      value: null,
      options: [],
      isMulti: true,
   },
   {
      name: "ABC Code:",
      label: "payload.abcCode",
      listName: "ABCCodeList",
      type: INPUT_TYPES.select,
      value: null,
      options: [],
   },
];

const SITE_OPTIONS = {
   Plant: 0,
   Warehouse: 1,
   Hamilton: 2,
};

const RadioButttonTypes = {
   All: 1,
   ORD: 2,
   XFER: 3,
};

export default function Production(props) {
   const [isExport, setIsExport] = useState(false);
   const [isLoading, setIsLoading] = useState(false);
   const [siteId, setSite] = useState("PLT");
   const [siteOpt, setSiteOpt] = useState(0);
   const [alreadyDisplayed, setAlreadyDisplayed] = useState([]);
   const [nonProdData, setNonProdData] = useState([]);
   const [productionPM, setProductionPM] = useState([]);
   const [hiddenColHeaders, setHiddenColHeaders] = useState([]);
   const [screenFields, setScreenFields] = useState({
      isLoading: true,
      screenItems: _.cloneDeep(FieldObjects),
      payload: {
         itemOrder: 1,
         orderRange: { label: "Two Weeks", value: "14" },
         classCode: "",
         abcCode: 0,
         vendor: "",
         itemNumberChecked: true,
         itemDescriptionPartialChecked: false,
         itemNumber: "",
         itemDescriptionPartial: "",
         siteId: "PLT",
      },
      checked: true,
   });
   const [classList, setClassList] = useState({});

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      const list = _.map(screenFields.screenItems, (x) => {
         if (x.type === INPUT_TYPES.select) {
            x.options = classList[x.listName];
         }
         return x;
      });

      setScreenFields({
         ...screenFields,
         screenItems: list,
         isLoading: false,
      });

      return () => {
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [classList.Success]);

   useEffect(() => {
      getItemClasses();
   }, []);

   const CreatePayload = () => {
      const copy = _.cloneDeep(screenFields);
      let defaultPayload = {
         EndDate: copy.payload?.orderRange?.value,
         ItemClass: _.join(_.map(copy.payload?.classCode, (x) => { return x?.value; }), ','),
         //ItemClass: copy.payload?.classCode?.value,  // Changed to mutli-select so use above
         ItemNumber: copy.payload?.itemNumber?.ddlValue,
         ItemOrder: copy.payload?.itemOrder,
         ItemDescriptionPartial: copy.payload?.itemDescriptionPartial,
         ItemNumberStart: "",
         ItemNumberEnd: "",
         ABCCode: copy.payload?.abcCode.value,
         VendorNumber: copy.payload?.vendor?.value,
         SiteId: siteId,
      };
      return defaultPayload;
   };

   const ExportXLS = () => {
      setIsExport(true);
      api
         .postGetBlob(
            "Purchasing/ExportProductionPurchasedMaterialXLSX",
            CreatePayload()
         )
         .then((r) => {
            if (r.data.success === false) {
               if (_.isString(r?.data?.message)) {
                  toast.error(r?.data?.message);
               }
               return;
            }
            if (r.data) {
               let XLSX_FILENAME = `PurchasedMaterialPlanning.xlsx`;
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_XLSX);
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .finally(() => setIsExport(false));
   }

   function getItemClasses() {
      api
         .post("Reference/GetItemClasses", { IsPurchasedMaterial: true })
         .then((response) => {
            if (response.data?.success) {
               return response.data;
            } else {
               toast.error("Failed to find itemClasses in GetItemClasses method");
            }
         })
         .then((data) => {
            data.itemClasses.unshift({ itemClassWithDesc: "--- All ---", itemClassCode: "" });
            setClassList({
               list: _.map(data.itemClasses, x => x.itemClassCode),
               ClassList: _.map(data.itemClasses, x => {
                  return { label: x.itemClassWithDesc, value: x.itemClassCode }
               }),
               OrderRangeList: [
                  { label: "One Week", value: "7" },
                  { label: "Two Weeks", value: "14" },
                  { label: "Four Weeks", value: "28" },
                  { label: "Six Weeks", value: "42" },
                  { label: "Eight Weeks", value: "56" },
                  { label: "Twelve Weeks", value: "84" },
                  { label: "Sixteen Weeks", value: "112" },
                  { label: "Twenty Weeks", value: "140" },
               ],
               ABCCodeList: constants.ABC_CODE_LIST,
               Success: true
            });
         })
         .catch(api.catchHandler)
   }

   function handleSiteChange(event) {
      const value = parseInt(event.target.value);
      if (value === 1)
         setSite("PLTWHSE");
      else if (value === 2)
         setSite("HAMI00");
      else
         setSite("PLT");

      setSiteOpt(value);
   };

   const LoadTable = () => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();

      setIsLoading(true);
      api
         .postS("Purchasing/ProductionPM", CreatePayload(), source.token)
         .then((response) => {
            if (response?.data?.success) {
               let colheaders = [];
               if (_.sumBy(response.data.productionData, x => x.hailideQty) > 0) colheaders.push({ displayName: "HAIL01", propertyName: "hailideQty" });
               if (_.sumBy(response.data.productionData, x => x.kolonQty) > 0) colheaders.push({ displayName: "KOLO01", propertyName: "kolonQty" });
               if (_.sumBy(response.data.productionData, x => x.safetyStockQty) > 0) colheaders.push({ displayName: "SSDANA", propertyName: "safetyStockQty" });
               if (_.sumBy(response.data.productionData, x => x.inTransitQty) > 0) colheaders.push({ displayName: "INTRANSIT", propertyName: "inTransitQty" });
               setHiddenColHeaders(colheaders);
               setProductionPM(response.data.productionData);
               setNonProdData(response.data.nonProdData);
            } else {
               toast.error("data was not returned");
            }
         })
         .catch(api.catchHandler)
         .finally(() => {
            setAlreadyDisplayed([]);
            setIsLoading(false);
         });
   };

   const onChange = (property, value, copy = null) => {
      if (copy === null) copy = _.cloneDeep(screenFields);
      _.set(copy, property, value);
      setScreenFields(copy);
      return;
   };

   const onChangeDynamicInputs = (property, value, idx) => {
      const copy = _.cloneDeep(screenFields);
      copy.screenItems[idx].value = value;
      onChange(property, value, copy);
   };

   const onChangeRow = (docNum) => {
      let newList = _.cloneDeep(alreadyDisplayed);
      if (_.includes(newList, docNum)) {
         setAlreadyDisplayed(_.filter(newList, (x) => x !== docNum));
      } else {
         newList.push(docNum);
         setAlreadyDisplayed(newList);
      }
   };

   const RadioButtonTypeAhead = (
      currentValue,
      PropertyToBecomeTrue,
      PropertyToBecomeFalse,
      PropertyToBecomeNull
   ) => {
      if (currentValue) return;
      const copy = _.cloneDeep(screenFields);
      _.set(copy, PropertyToBecomeTrue, true);
      _.set(copy, PropertyToBecomeFalse, false);
      _.set(copy, PropertyToBecomeNull, "");
      setScreenFields(copy);
   };

   function replacer(key, value) {
      // Encode # symbol in item string for inventory dashboard link
      if (typeof value === 'string')
         return value.replace(/#/g, '%23');

      return value;
   }

   function TableNeeds({ data, alreadyDisplayed, onChange, hiddenHdrs }) {
      const [displayed, setDisplayed] = useState([]);

      useEffect(() => {
         if (!_.isEqual(displayed, alreadyDisplayed)) {
            setDisplayed(alreadyDisplayed);
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [alreadyDisplayed])

      return (
         _.map(data, (d, index) => {
            return (
               <CollapseTablePmNeeds
                  collapse={_.includes(alreadyDisplayed, d.purchasedItem)}
                  row={d}
                  docNum={d.purchasedItem}
                  onChangeCallback={(d) => onChangeRow(d)}
                  key={index}
                  hiddenHdrs={hiddenHdrs}
               />
            );
         })
      )
   }

   return (
      <DesktopContainer screenName={"Production PM Needs"}>
         <Card className="dashboard-card">
            <CardBody>
               <div className="filter-header mb-3">
                  {!screenFields.isLoading &&
                     _.map(screenFields.screenItems, (x, index) => {
                        return (
                           <DynamicInput
                              key={`${index}-abc`}
                              obj={x}
                              idx={index}
                              onChangeCallback={(property, value, idx) => onChangeDynamicInputs(property, value, idx)}
                           />
                        );
                     })}

                  <Row xs="" className="mt-2">
                     <Col xs="3" style={{ textAlign: "right", marginTop: "6px" }}>
                        <h5 className="text-white">Vendor:</h5>
                     </Col>
                     <Col xs="6">
                        <VendorTypeahead
                           value={screenFields.payload.vendor}
                           onChange={(opt) => onChange("payload.vendor", opt)}
                        />
                     </Col>
                  </Row>

                  <Row className="my-1 mb-0">
                     <Col xs="3" style={{ textAlign: "right", marginTop: "6px" }}>
                        <h5 className="text-white">Location:</h5>
                     </Col>
                     <Col xs="9">
                        <FormGroup check inline>
                           <Label check className="text-white">
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Plant}
                                 checked={siteOpt === SITE_OPTIONS.Plant}
                                 onChange={handleSiteChange}
                              />{" "}
                              PLT
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check className="text-white">
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Warehouse}
                                 checked={siteOpt === SITE_OPTIONS.Warehouse}
                                 onChange={handleSiteChange}
                              />{" "}
                              PLTWHSE
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check className="text-white">
                              <Input
                                 type="radio"
                                 name="siteOption"
                                 value={SITE_OPTIONS.Hamilton}
                                 checked={siteOpt === SITE_OPTIONS.Hamilton}
                                 onChange={handleSiteChange}
                              />{" "}
                              HAMI00
                           </Label>
                        </FormGroup>
                     </Col>
                  </Row>

                  <Row xs="" className="mt-2">
                     <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 className="text-white">Item Number:</h5>
                     </Col>
                     <Col xs="1" style={{ paddingRight: "0px" }}>
                        <Input
                           type="checkbox"
                           name={"ItemNumber"}
                           checked={screenFields.payload.itemNumberChecked}
                           onChange={() =>
                              RadioButtonTypeAhead(
                                 screenFields.payload.itemNumberChecked,
                                 "payload.itemNumberChecked",
                                 "payload.itemDescriptionPartialChecked",
                                 "payload.itemDescriptionPartial"
                              )}
                        />
                     </Col>
                     {screenFields.payload.itemNumberChecked && (
                        <Col xs="4">
                           <ItemTypeahead
                              value={screenFields.payload.itemNumber}
                              onChange={(opt) => onChange("payload.itemNumber", opt)}
                           />
                        </Col>
                     )}
                  </Row>

                  <Row xs="" className="mt-2">
                     <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }}>
                        <h5 className="text-white">Item Description Partial:</h5>
                     </Col>
                     <Col xs="1" style={{ paddingRight: "0px" }}>
                        <Input
                           type="checkbox"
                           name={"ItemDescriptionPartial"}
                           checked={screenFields.payload.itemDescriptionPartialChecked}
                           onChange={() =>
                              RadioButtonTypeAhead(
                                 screenFields.payload.itemDescriptionPartialChecked,
                                 "payload.itemDescriptionPartialChecked",
                                 "payload.itemNumberChecked",
                                 "payload.itemNumber"
                              )}
                        />
                     </Col>
                     {screenFields.payload.itemDescriptionPartialChecked && (
                        <Col xs="4">
                           <Input
                              type="text"
                              name={"ItemDescriptionPartial"}
                              value={screenFields.payload.itemDescriptionPartial}
                              onChange={(e) => {
                                 onChange("payload.itemDescriptionPartial", e.target.value);
                              }}
                           />
                        </Col>
                     )}
                  </Row>

                  <Row className="my-1 mb-0">
                     <Col xs={{ offset: 3, size: 1 }} style={{ textAlign: "left", marginRight: "5px" }}>
                        <Button className="shredButton" onClick={LoadTable}>
                           LOAD
                        </Button>
                     </Col>
                     <Col xs="6">
                        <FormGroup check inline>
                           <Label check className="text-white">
                              <Input
                                 type="radio"
                                 name="itemOrder"
                                 //defaultChecked={true}
                                 value={RadioButttonTypes.All}
                                 checked={screenFields.payload.itemOrder === RadioButttonTypes.All}
                                 onChange={() => onChange("payload.itemOrder", RadioButttonTypes.All)}
                              />{" "}
                              All
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check className="text-white">
                              <Input
                                 type="radio"
                                 name="itemOrder"
                                 value={RadioButttonTypes.ORD}
                                 checked={screenFields.payload.itemOrder === RadioButttonTypes.ORD}
                                 onChange={() => onChange("payload.itemOrder", RadioButttonTypes.ORD)}
                              />{" "}
                              Critical Items Only
                           </Label>
                        </FormGroup>
                        <FormGroup check inline>
                           <Label check className="text-white">
                              <Input
                                 type="radio"
                                 name="itemOrder"
                                 value={RadioButttonTypes.XFER}
                                 checked={screenFields.payload.itemOrder === RadioButttonTypes.XFER}
                                 onChange={() => onChange("payload.itemOrder", RadioButttonTypes.XFER)}
                              />{" "}
                              Transfer Items Only
                           </Label>
                        </FormGroup>
                     </Col>
                  </Row>
               </div>

               <ServiceThreadSpinner on={isLoading}>
                  {productionPM && productionPM.length !== 0 ? (
                     <>
                        <Row className={"mb-2"}>
                           <Col xs={{ offset: 6, size: 6 }} className="transparent-background">
                              <SpinnerButton
                                 title="Download as .xlsx"
                                 className="shredButtonExcel float-end ms-2"
                                 on={isExport}
                                 onClick={ExportXLS}
                                 disabled={isExport}
                              >
                                 <FontAwesomeIcon icon="file-excel" size="lg" />
                              </SpinnerButton>
                           </Col>
                        </Row>
                        <Row className="my-3 px-2">
                           <Col xs="1" className="custom-table-header-top-left"></Col>
                           <Col xs="2" className="table-header py-1">Item</Col>
                           <Col className="table-header py-1">QC Hold</Col>
                           <Col className="table-header py-1">Required Critical</Col>
                           <Col className="table-header py-1">Needed</Col>
                           <Col className="table-header py-1">Status</Col>
                           <Col className="table-header py-1">PLT</Col>
                           <Col className="table-header py-1">PLTWHSE</Col>
                           {_.isEmpty(hiddenColHeaders) ? null :
                              _.map(hiddenColHeaders, (x, colIdx) => {
                                 return (<Col key={colIdx} className="table-header py-1">{x.displayName}</Col>);
                              })
                           }
                           <Col xs="1" className="custom-table-header-top-right py-1">On Order</Col>
                        </Row>
                        <TableNeeds data={productionPM} alreadyDisplayed={alreadyDisplayed} onChange={onChangeRow} hiddenHdrs={hiddenColHeaders} />
                     </>
                  ) : (
                     <div className="mt-5" style={{ textAlign: "center" }}>
                        <span>Results Not Found</span>
                     </div>
                  )}

                  <br />
                  <hr />
                  <label className="fw-bold title">Scheduled Items with No PM Needs</label>
                  {nonProdData && nonProdData.length !== 0 ? (
                     <Table size="sm" className="data-table">
                        <thead className="table-header">
                           <tr>
                              <th style={{ width: "25%" }}>Item</th>
                              <th>Build Qty +10%</th>
                              <th>On Hand</th>
                              <th>Available</th>
                              <th>On Order</th>
                              <th>Order Point</th>
                              <th>Scheduled</th>
                           </tr>
                        </thead>
                        <tbody>
                           {_.map(nonProdData, (d, idx) => {
                              return (
                                 <tr key={idx}>
                                    <td className="data-cell">
                                       <Link
                                          className="shredLink fw-bold"
                                          to={constants.ENDPOINTS.inventoryDashboard}
                                          onClick={() => localStorage.setItem("itemNumber", JSON.stringify({
                                             label: d.itemWithDesc,
                                             value: d.itemnmbr
                                          }, replacer))}
                                          target="_blank"
                                       >
                                          {_.trim(d.itemWithDesc)}
                                       </Link>
                                    </td>
                                    <td className={"data-cell"}>{Math.round(d.quantityToBuildPounds).toLocaleString()}</td>
                                    <td className={"data-cell"}>{Math.round(d.qtyonhnd).toLocaleString()}</td>
                                    <td className={"data-cell"}>{Math.round(d.available).toLocaleString()}</td>
                                    <td className={"data-cell"}>{Math.round(d.releaseTotal).toLocaleString()}</td>
                                    <td className={"data-cell"}>{Math.round(d.ordrpntqty).toLocaleString()}</td>
                                    <td className={"data-cell"}>{(d.scheduled === true) ? "Yes" : "No"}</td>
                                 </tr>
                              )
                           })};
                        </tbody>
                     </Table>
                  ) : (
                     <div className="mt-5" style={{ textAlign: "center" }}>
                        <span>Results Not Found</span>
                     </div>
                  )}
               </ServiceThreadSpinner>
            </CardBody>
         </Card>
      </DesktopContainer>
   );
}
